export class SamplersDTO {
    SamplerPuidList: string[] = []
}